'use strict'

import {TweenLite, TweenMax, TimelineMax} from 'gsap';

let self

export default self = {
  container: document.querySelector('#contact-page'),
  emailForm: document.querySelector('.email-form'),
  titleBox: document.querySelector('.contact-title-box'),
  titleFirst: document.querySelector('.contact-title--first'),
  titleSecond: document.querySelector('.contact-title--second'),
  titleSign: document.querySelector('.contact-title--sign'),
  text: document.querySelector('.contact-text'),
  signBtn: document.querySelector('#contact-page .button'),

  contactFormsContainer : document.querySelector('.contact-forms-container'),

  init : () => {
    self.firstLoad();

    self.emailForm.addEventListener('click', ()=>{
      if(!self.container.classList.contains('showed')){
        self.show();
      }
    });

    self.setupFormToggle()
  },

  setupFormToggle : () => {
    self.formToggleBtns = [...self.contactFormsContainer.querySelectorAll('nav button')]

    self.formToggleBtns.forEach( button => button.addEventListener('click', self.toggleForms) )
  },

  toggleForms : e => {
    const targetButton = e.currentTarget
    const activeButton = self.contactFormsContainer.querySelector('nav button.active')
    const rel = targetButton.getAttribute('rel')
    const activeForm = self.contactFormsContainer.querySelector('article.active')
    const targetForm = self.contactFormsContainer.querySelector(`article[rel=${rel}]`)

    activeButton.classList.remove('active')
    targetButton.classList.add('active')

    activeForm.classList.remove('active')
    targetForm.classList.add('active')
  },

  firstLoad : () => {
    const info = document.querySelectorAll('.contact-info')
    const mlsDisclaimer = document.querySelector('.mlsDisclaimer')

    const tlLoad = new TimelineLite();

    return tlLoad
      .set([self.titleBox, self.titleSecond], {autoAlpha: 0})
      .set([self.emailForm, self.signBtn], {autoAlpha: 0, y: -20})
      .set(document.documentElement, {className: '+=contact-animating'})
      .to(self.titleBox, 0.6 ,{autoAlpha: 1})
      .to(self.titleFirst, 0.4, {autoAlpha: 0}, '+=1.6')
      .to(self.titleSecond, 0.5, {autoAlpha: 1})
      .to(self.titleSecond, 0.5, {autoAlpha: 0}, '+=1.6')
      .set(self.titleBox, {className: '-=animating'})
      .set(self.titleBox, {display: 'none'})
      .set(self.titleSign, {display: 'block', y: -20})
      .set(info, {y: -20})
      .to(self.titleSign, 0.3, {autoAlpha: 1, y: 0}, '+=0.5')
      .to(self.text, 0.3, {autoAlpha: 1, y: 0})
      .to('.contact-forms-container', 0.3, {autoAlpha: 1})
      .to(self.emailForm, 0.3, {autoAlpha: 1, y: 0})
      .to(self.signBtn, 0.3, {autoAlpha: 1, y: 0})
      .staggerTo(info, 0.4, {autoAlpha: 1, y: 0}, 0.2)
      .to(mlsDisclaimer, 0.3, {autoAlpha: 1})
      .set(document.documentElement, {className: '-=contact-animating'});

  },

  show : () => {
    const fname = document.getElementById('mce-FNAME')
    const lname = document.getElementById('mce-LNAME')
    const phone = document.getElementById('mce-PHONE')
    const interested = document.getElementById('mce-INTERESTED')
    const notifications = document.getElementById('mce-NOTIFICATIONS')
    const checkBox = document.querySelector('.check-box')

    const tlShow = new TimelineLite()

    return tlShow
      .add('show')
      .set(self.container, {className:'showed'})
      .to(self.emailForm, 0.3, {left: 0}, 'show')
      .to(fname, 0.3, {display: 'inline', autoAlpha: 1},'show')
      .to(lname, 0.3, {display: 'inline', autoAlpha: 1},'show')
      .to(phone, 0.3, {display: 'inline', autoAlpha: 1},'show')
      .to(interested, 0.3, {display: 'inline', autoAlpha: 1},'show')
      .to(notifications, 0.3, {display: 'inline', autoAlpha: 1},'show')
      .from(checkBox, 0.3, {height:28}, 'show');


  }


}
